import React, {Component, Fragment,} from 'react';

import {APP_BOOLEANS, APPLICATION_MODES,} from 'localConstants';

import {ALERT_MESSAGES, API_SOURCE, PREDICTION_SOURCE,} from '../../../../../constants/appConstants';
import {trimCapitalize} from '../../../../../utils/stringUtil';
import {TatvamButton, TatvamCol, TatvamGrid, TatvamModal,} from '../../../../functionalComponents';
import AlertBox from '../../../alertBox';
import PredictionSourceForm from '../../../predictionSourceForm';

class PredictionSources extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            sourceGridData: [],
            loader: true,
            colDef: [
                {headerName: PREDICTION_SOURCE.SOURCENAME, field: "name", filterParams: {clearButton: true}},
                {
                    headerName: PREDICTION_SOURCE.EXTRACTION_TYPE,
                    field: "source_name",
                    filterParams: {clearButton: true}
                },
                {
                    headerName: API_SOURCE.VIEW_EXECUTION_DATE,
                    field: "last_execution.execution_date",
                    filterParams: {clearButton: true}
                },
                {headerName: PREDICTION_SOURCE.STATUS, field: "status", filterParams: {clearButton: true}},
            ]
        };
    }

    _handleDeleteConfirmation = (data) => {
        this.setState({
            idCustomer: data.customer_id,
            idSource: data.source_id,
            idUnique: data._id,
            isConfirmBox: true,
            isAlertBoxOpen: false,
            isDeleteAlertBoxOpen: true,
            isSuccess: false,
            alert_information: ALERT_MESSAGES.DELETE_CONFIRMATION
        });
    };
    _deleteRow = (data) => {
        if (data === "ok") {
            let customer_id = this.state.idCustomer;
            let id = this.state.idUnique;
            let sourceDeleteData = {
                customer_id,
                id
            };
            this.props.actions.deletePredictoSource(sourceDeleteData).then((response) => {
                this.setState({
                    preLoader: false
                });
                if (response.status === 200) {

                    let tempSourceGridData = this.state.sourceGridData.filter((data) => data.id !== sourceDeleteData.id);
                    this.setState({
                        sourceGridData: tempSourceGridData
                    })
                    this.setState({
                        shouldCloseModal: true,
                        isAlertBoxOpen: true,
                        isSuccess: true,
                        alert_information: response.data.message
                    });
                } else {

                    this.setState({
                        shouldCloseModal: false,
                        isAlertBoxOpen: true,
                        isSuccess: false,
                        alert_information: response.data ? response.data.message : response.message
                    });

                }
            });

        }
        this.setState({
            isConfirmBox: false,
            isAlertBoxOpen: false,
            isSuccess: false,
            isDeleteAlertBoxOpen: false
        });
    }
    _discard = (data) => {
        this.setState({
            isConfirmBox: false,
            isAlertBoxOpen: false,
            isSuccess: false
        });
    };

    _openViewModal = (data) => {
        this.setState({
            sourceData: data,
            title: "",
            applicationMode: APPLICATION_MODES.VIEW,
            isModalOpen: true
        });
    };
    _openCreateModal = () => {
        this.setState({
            sourceData: [],
            title: PREDICTION_SOURCE.ADD_TITLE_SOURCE,
            applicationMode: APPLICATION_MODES.CREATE,
            isModalOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            isModalOpen: false
        });
    };

    _handleCreateRecord = (record) => {
        this.setState({sourceGridData: [...this.state.sourceGridData, record]});
    }

    _handleEditRecord = (record) => {
        let recordIndex = -1;
        let sourceGridData = this.state.sourceGridData;
        this.state.sourceGridData.map((data, index) => {
            if (data.id === record.id) {
                recordIndex = index;
            }
        });
        if (recordIndex > -1) {
            this.setState({sourceGridData: []})
            sourceGridData[recordIndex] = record;
            this.setState({sourceGridData})
        }
    }

    componentDidMount() {
        this.setState({
            loader: true
        });
        let sourceGridData = [];
        this.props.actions.getCustomerPredictoSourceDetails(this.props.currentCustomerId).then(() => {
            this.setState({
                loader: false
            });
        });

        if (this.props.predictoData) {
            this.props.predictoData.map((data) => {
                let status = trimCapitalize(data.status);
                if (status === APPLICATION_MODES.ACTIVE || status === APPLICATION_MODES.INACTIVE) {
                    if (data.last_execution && data.last_execution.execution_date !== "") {
                        let execution_date = new Date(data.last_execution.execution_date).toDateString().replace('-', '').split(" ");
                        data.execution_date = execution_date[2] + "-" + execution_date[1] + "-" + execution_date[3];
                    }
                    sourceGridData.push(data);
                }
            });
        }
        this.setState({
            sourceGridData
        }, () => {
            this.setActiveCount();
        });
    }


    componentWillReceiveProps(props) {
        let sourceGridData = [];
        if (props.predictoData) {
            props.predictoData.map((data) => {
                let status = trimCapitalize(data.status);
                if (status === APPLICATION_MODES.ACTIVE || status === APPLICATION_MODES.INACTIVE) {
                    if (data.last_execution && data.last_execution.execution_date !== "") {
                        let execution_date = new Date(data.last_execution.execution_date).toDateString().replace('-', '').split(" ");
                        data.execution_date = execution_date[2] + "-" + execution_date[1] + "-" + execution_date[3];
                    }
                    sourceGridData.push(data);
                }
            });
        }
        this.setState({
            sourceGridData
        }, () => {
            this.setActiveCount();
        });
    }

    setActiveCount = () => {
        let gridData = this.state.sourceGridData;
        let noOfActive = gridData.filter(eachItem => eachItem.status === APPLICATION_MODES.ACTIVE);
        this.props.countPropagate({'predictoSource': {'active': noOfActive.length, 'total': gridData.length}});
    };

    render() {
        return (
            <Fragment>
                {this.props.sourcePermission === APP_BOOLEANS.TRUE && (
                    <TatvamButton className="btn_primary right mt-1 mr-2" onClick={this._openCreateModal}>
                        {API_SOURCE.ADD_SOURCE}
                    </TatvamButton>
                )}

                {this.state.isModalOpen && (
                    <TatvamModal
                        open={this.state.isModalOpen}
                        header={this.state.title}
                        options={{dismissible: false}}
                        fixedFooter={false}
                        className="hideFooter"
                        children={(
                            <PredictionSourceForm
                                sourceData={this.state.sourceData}
                                gridData={this.state.sourceGridData}
                                customerId={this.props.currentCustomerId}
                                applicationMode={this.state.applicationMode}
                                customerData={this.props.customer}
                                closeModal={this.closeModal}
                                handleCreateRecord={this._handleCreateRecord}
                                handleEditRecord={this._handleEditRecord}
                            />
                        )}
                    />
                )}

                {this.state.sourceGridData && this.state.sourceGridData.length ? (
                        <TatvamCol s={12} className="grid-data-area">
                            <TatvamGrid
                                gridData={this.state.sourceGridData}
                                colData={this.state.colDef}
                                onRowSelect={this._openViewModal}
                                enableDeleteColumn={this.props.sourceDelete === APP_BOOLEANS.TRUE}
                                onRowDelete={this._handleDeleteConfirmation}

                            />
                        </TatvamCol>
                    ) :
                    this.state.loader ? (
                        <TatvamCol s={12} className="grid-empty-area">
                            <h5>
                                Loading...
                            </h5>

                        </TatvamCol>
                    ) : (
                        <TatvamCol s={12} className="grid-empty-area">
                            <h5>
                                {PREDICTION_SOURCE.NO_PREDICTION_SOURCE_AVAILABLE}
                            </h5>

                        </TatvamCol>
                    )
                }
                {this.state.isAlertBoxOpen && (
                    <AlertBox
                        open={this.state.isAlertBoxOpen}
                        isSuccess={this.state.isSuccess}
                        closeAlertBox={this._discard}
                        isConfirmBox={this.state.isConfirmBox}
                        alert_information={this.state.alert_information}
                    />
                )}
                {this.state.isDeleteAlertBoxOpen && (
                    <AlertBox
                        open={this.state.isDeleteAlertBoxOpen}
                        isSuccess={this.state.isSuccess}
                        closeAlertBox={this._deleteRow}
                        isConfirmBox={this.state.isConfirmBox}
                        alert_information={this.state.alert_information}
                    />
                )}
            </Fragment>
        );
    }
}

export default PredictionSources;
